import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';
import moment from 'moment';

const firebaseRef = firebase.database();

export function getLeadsNumberBySalesAgentId(
	salesAgentId,
	filterByDate,
	callback
) {
	firebaseRef
		.ref('/kavtek_leads/' + PROJECT_CODE.projectCode)
		.on('value', (snapshot) => {
			try {
				let leadsParent = snapshot.val();
				if (leadsParent) {
					let leadsKeys = Object.keys(leadsParent);
					let filteredKeys = leadsKeys
						.filter(
							(leadsKey) => leadsParent[leadsKey].leadToSalesAgent
						)
						.filter(
							(leadsKey) =>
								leadsParent[leadsKey].leadToSalesAgent ===
								salesAgentId
						)
						.filter((leadsKey) => {
							if (leadsParent[leadsKey]?.createTimestamp) {
								if (filterByDate === 'All') {
									return true;
								} else if (filterByDate === 'Month') {
									return moment(
										leadsParent[leadsKey].createTimestamp
									).isBetween(
										moment().subtract(1, 'months'),
										moment()
									);
								} else if (filterByDate === 'Week') {
									return moment(
										leadsParent[leadsKey].createTimestamp
									).isBetween(
										moment().subtract(7, 'days'),
										moment()
									);
								} else if (filterByDate === 'Today') {
									return moment(
										leadsParent[leadsKey].createTimestamp
									).isBetween(
										moment().startOf('day'),
										moment()
									);
								} else {
									return true;
								}
							} else {
								return true;
							}
						});
					callback(filteredKeys.length);
				} else {
					callback(0);
				}
			} catch {
				callback(0);
			}
		});
}

export function getLeadsTotalNumber(filterByDate, callback) {
	firebaseRef
		.ref('/kavtek_leads/' + PROJECT_CODE.projectCode)
		.on('value', (snapshot) => {
			try {
				let leadsParent = snapshot.val();
				if (leadsParent) {
					let leadsKeys = Object.keys(leadsParent);
					let filteredLeadsKeys = leadsKeys.filter((leadsKey) => {
						if (leadsParent[leadsKey]?.createTimestamp) {
							if (filterByDate === 'All') {
								return true;
							} else if (filterByDate === 'Month') {
								return moment(
									leadsParent[leadsKey].createTimestamp
								).isBetween(
									moment().subtract(1, 'months'),
									moment()
								);
							} else if (filterByDate === 'Week') {
								return moment(
									leadsParent[leadsKey].createTimestamp
								).isBetween(
									moment().subtract(7, 'days'),
									moment()
								);
							} else if (filterByDate === 'Today') {
								return moment(
									leadsParent[leadsKey].createTimestamp
								).isBetween(moment().startOf('day'), moment());
							} else {
								return true;
							}
						} else {
							return true;
						}
					});
					callback(filteredLeadsKeys.length);
				} else {
					callback(0);
				}
			} catch {
				callback(0);
			}
		});
}
